import { Row as BootstrapRow, Col } from "react-bootstrap";

import styled from "styled-components";

export const GroupLabel = styled.label`
    margin: auto 0.5rem;
    font-size: ${globalThis.config.fonts.sizes.xsmall};
    font-family: ${globalThis.config.fonts.families.medium};
`;

export const Wrapper = styled(BootstrapRow)`
    border-bottom: ${globalThis.config.border.small};
    background: ${(props) => {

        if (props.$groupHeader) {
            return "#fff7f3";
        }

        return props.selected
            ? globalThis.config.colors.gray9
            : "transparent";
    }};
    margin: 0;

    &:hover {
        background: ${(props) => !props.selected && globalThis.config.colors.gray9};
    }
    .rightArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.gray3};
        }
    }
`;

export const Column = styled(Col)`
    border-right: ${globalThis.config.border.small};
    padding: 0;
    &:last-child {
        border-right: none;
    }

    &:hover {
        #moreButton {
            margin-left: 0px;
            display: flex;
            -ms-flex-align: center;
            -webkit-align-items: center;
            -webkit-box-align: center;
            align-items: "center";
            justify-content: "center";
        }
    }
`;

export const WrapperGroup = styled.div`
    display: flex;
    padding: 0.3rem 0.5rem 0.3rem 0;
`;

export const WrapperAction = styled.div`
    display: flex;
    min-width: 1.25rem;
    width: 1.25rem;
    max-width: 1.25rem;
`;
